import React from "react";
import Page from "./../components/Page";
import SEO from "./../components/SEO";
import WithSideNav from "../components/WithSideNav";
import Section from "../components/Section";

function TeamPage() {
  const sideNavProps = [
    {
      title: "About Us",
      link: "/about"
    },
    {
      title: "Team & Collaborators",
      link: "/team"
    },
    {
      title: "Support & Collaborate",
      link: "/get-support"
    },
    {
      title: "Funding History",
      link: "/history"
    }
  ];

  return (
    <Page>
      <SEO title="About | OHIF" />
      <Section>
        <WithSideNav sideNavProps={sideNavProps} title="About">
          <div className="text-white">
            The Open Health Imaging Foundation (OHIF) was launched in 2015 through a development collaboration between{' '}
            <a
              href="https://www.massgeneral.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-100 hover:opacity-75"
            >
              Massachusetts General Hospital (MGH)
            </a>{' '}Department of Radiology and{' '}
            <a
              href="https://radicalimaging.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-100 hover:opacity-75"
            >
              Radical Imaging
            </a>
            , a software engineering firm focused on serving the needs of the OHIF community. The collaboration combines the project management, user experience design, and product testing experience of the MGH group with the software development and system design expertise of Radical Imaging.
          </div>
          <div className="text-white">
            Funding for OHIF has been primarily through research grants to MGH, direct funding from MGH Department of Radiology, Radical Imaging through in-kind support, and academic-industry technical collaborations among MGH, Radical, and companies using the OHIF Framework.
          </div>
          <div className="text-white">
            Learn more about OHIF's commercially-permissive{' '}
            <a
              href="https://github.com/OHIF/Viewers/blob/master/LICENSE"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-100 hover:opacity-75"
            >
              MIT open source software license
            </a>
            .
          </div>
        </WithSideNav>
      </Section>
    </Page>
  );
}

export default TeamPage;
